import { EventsToNotifyOn } from '#/protobuf/enums_pb';

// this function is used to determine if any notification type is turned on given an EventsToNotifyOn compatible number.
export function anyNotifyIsOn(eventsToNotifyOn) {
  return eventsToNotifyOn > 0;
}

// this function is used to determine if Job Start notifications are turned on given an EventsToNotifyOn compatible number.
export function isNotifyOnJobStart(eventsToNotifyOn) {
  // eslint-disable-next-line no-bitwise
  return (eventsToNotifyOn & EventsToNotifyOn.EVENT_NOTIFICATION_JOB_INIT) !== 0;
}

// this function is used to determine if Job Finish notifications are turned on given an EventsToNotifyOn compatible number.
export function isNotifyOnJobFinish(eventsToNotifyOn) {
  // eslint-disable-next-line no-bitwise
  return (eventsToNotifyOn & EventsToNotifyOn.EVENT_NOTIFICATION_JOB_FINALIZE) !== 0;
}
